export default {
  // 测试
  // baseUrl: 'http://jiuye.first.xinzhidi.cn/',
  // 线上
  baseUrl: "https://api.istv.cn/",
};
